import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { EmailService } from '@core/services/email.service';
import { AlertComponent } from '@shared/alert/alert.component';

@Component({
  selector: 'app-verify-email',
  standalone: true,
  imports: [CommonModule, RouterModule, AlertComponent],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.css'
})
export class VerifyEmailComponent implements OnInit {
  email: string = '';
  isResending: boolean = false;

  // Toast
  show = false;
  toastTitle = '';
  toastMessage = '';
  toastType: 'info' | 'success' | 'warning' | 'alert' = 'info';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private emailService: EmailService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'] || '';

      // Si no hay email, redirigir al registro
      if (!this.email) {
        this.router.navigate(['/register']);
      }
    });
  }

  async resendVerificationEmail(): Promise<void> {
    if (this.isResending || !this.email) return;

    this.isResending = true;

    try {
      await this.emailService.resendVerification(this.email).toPromise();
      this.showToast('success', 'Correo enviado', 'Se ha reenviado el correo de verificación.');
    } catch (error: any) {
      const errorMessage = error?.error?.message || 'Error al reenviar el correo de verificación.';
      this.showToast('alert', 'Error', errorMessage);
    } finally {
      this.isResending = false;
    }
  }

  changeEmail(): void {
    this.router.navigate(['/register']);
  }

  goToLogin(): void {
    this.router.navigate(['/']);
  }

  showToast(type: 'info' | 'success' | 'warning' | 'alert', title: string, message: string): void {
    this.toastType = type;
    this.toastTitle = title;
    this.toastMessage = message;
    this.show = true;

    setTimeout(() => {
      this.show = false;
    }, 4000);
  }
}